export default {
  Title: 'Confirm & Submit Application',
  Subtitle: 'Please review your information before submitting your caregiver application',
  ClickToEdit: 'Click on any section below to edit your information',
  CertificationsTitle: 'Professional Certifications/Licenses',
  SkillsAndLanguagesTitle: 'Caregiving Skills and Languages',
  SkillsLabel: 'Skills and Services:',
  LanguagesLabel: 'Languages:',
  WorkHistoryTitle: 'Work History',
  PersonalityAssessmentTitle: 'Personality Assessment',
  WorkAvailabilityTitle: 'Work Availability',
  TravelPreferencesTitle: 'Travel Preferences',
  WorkEligibilityTitle: 'Work Eligibility',
  ContactInformationTitle: 'Contact Information',
  AgreementsTitle: 'Agreements',
  CertificationsInvalidMessage: 'No professional certifications/licenses selected yet. Please complete the Certifications section.',
  SkillsAndLanguagesInvalidMessage: 'You need to select at least one skill and one language. Please complete the Skills & Languages section.',
  WorkHistoryInvalidMessage: 'Work history section incomplete. Please complete the Work History section.',
  PersonalityInvalidMessage: 'Personality assessment not completed. Please complete the Personality section.',
  AvailabilityInvalidMessage: 'Work availability not set. Please complete the Availability section.',
  TravelInvalidMessage: 'Travel preferences not set. Please complete the Travel section.',
  EligibilityInvalidMessage: 'Work eligibility status not selected. Please complete the Eligibility section.',
  ContactInvalidMessage: 'Contact information incomplete. Please complete the Contact section.',
  AgreementsInvalidMessage: 'You must to agree to all items. Please complete the Agreements section.',
  SkillsSelectedCount: '#{count} skills selected',
  ApplicationReadyTitle: 'Application Ready to Submit',
  ApplicationReadyDescription: 'Your caregiver application is complete and ready for review. ' +
    'Click submit to save your application and proceed to the interview.',
  SubmitButton: 'Submit Application',
  ApplicationSubmitted: 'Application Submitted',
  SubmittedSuccessfully: '✓ Application submitted successfully!',
  CompleteAllSectionsTitle: 'Complete All Sections',
  CompleteAllSectionsDescription: 'Please complete all previous sections before submitting your application.',
  CompleteAllSectionsButton: 'Complete Application First',
  SubmittedMessage: 'Application Submitted Successfully!',
  CompletionWarning: 'Please complete all sections before submitting your application.',
  OneMorePosition: '+1 more position',
  MorePositions: '+#{count} more positions',
  CompanyFallback: 'Company',
  StartDateLabel: 'Start',
  PresentLabel: 'Present',
  PersonalityAssessmentCompleted: 'Personality assessment completed with #{count} responses',
  AvailableDays: 'Available Days:',
  Hours: 'hours',
  HoursShort: 'hrs',
  MaxTravelTime: 'max travel time',
  NoAvailabilitySelected: 'No availability selected yet.',
  ReferenceAvailable: 'Reference available',
  Contact: 'Contact',
};
